<template>
  <div>
    <div class="body" v-if="contests.length">
      <contest-row v-for="contest in contests" :key="contest.id" :contest="contest" class="row" />
    </div>
    <div v-else class="empty">{{ $t('homePage.contest.noContests') }}</div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import ContestRow from "@/components/molecules/ContestRow.vue";

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    ContestRow,
  },
  props: {
    contests: Array,
  },
});

interface Props {
  contests: object[];
}

interface Data {}

interface Computed {}

interface Methods {}
</script>

<style lang="scss" scoped>
@import "@/style-common.scss";

.body {
  margin-bottom: 10px;

  .row {
    position: relative;
    @include hover-overlay;
    margin-bottom: 1em;

    &:last-of-type {
      margin-bottom: 0;
    }

  }
}

.empty {
  display: flex;
  justify-content: center;
  align-items: center;
  margin: 30px;
  font-weight: var(--font-weight-bold);
  font-size: var(--font-size-md);
  color: var(--color-text-normal);
}
</style>
